import { API_ENDPOINT } from 'env'

// Projetos elegíveis a LBC de uma empresa/ano (o Gerente é global e escolhe a empresa de origem).
export const getProjetosElegiveis = async ({ empresaId, ano }) => {
  const parsed = JSON.parse(localStorage.getItem('state'))
  const res = await fetch(
    `${API_ENDPOINT}/certificados-lbc/projetos-elegiveis?empresaId=${empresaId}&ano=${ano}`,
    {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${parsed.auth.token}` },
    },
  )
  if (!res.ok) throw new Error('Erro ao buscar projetos')
  return res.json()
}
